var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: [_vm.textEli ? "text-eli" : ""] },
    [
      _vm.type === "systemUser"
        ? [
            _c(
              "el-popover",
              {
                attrs: { effect: "light", placement: "top", trigger: "click" },
                on: {
                  show: function ($event) {
                    return _vm.queryUserInfo(_vm.query.userId)
                  },
                },
              },
              [
                _c(
                  "el-descriptions",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.userLoading,
                        expression: "userLoading",
                      },
                    ],
                    attrs: { column: 1, border: "" },
                  },
                  [
                    _c("el-descriptions-item", { attrs: { label: "手机号" } }, [
                      _vm._v(_vm._s(_vm.userInfo.mobile)),
                    ]),
                    _c("el-descriptions-item", { attrs: { label: "供应商" } }, [
                      _vm._v(_vm._s(_vm.userInfo.merchantName)),
                    ]),
                  ],
                  1
                ),
                _c("template", { slot: "reference" }, [
                  _c("span", { staticClass: "link" }, [
                    _vm._v("\n          " + _vm._s(_vm.label) + "\n        "),
                  ]),
                ]),
              ],
              2
            ),
          ]
        : [
            _c(
              "el-tooltip",
              {
                attrs: {
                  placement: "right",
                  effect: "dark",
                  trigger: "hover",
                  disabled: !_vm.needCopy,
                },
                scopedSlots: _vm._u([
                  {
                    key: "content",
                    fn: function () {
                      return [
                        _c(
                          "span",
                          {
                            staticStyle: { cursor: "pointer" },
                            on: {
                              click: function ($event) {
                                return _vm.copyOrderNo(_vm.value)
                              },
                            },
                          },
                          [_vm._v("复制")]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              },
              [
                _vm.isPermi && _vm.value
                  ? _c(
                      "a",
                      {
                        staticClass: "label-color",
                        class: _vm.need ? "link" : "",
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.clickEvent.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("\n        " + _vm._s(_vm.label) + "\n      ")]
                    )
                  : _c("span", [_vm._v(_vm._s(_vm.label))]),
              ]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }